import { useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import Modal from 'react-bootstrap/Modal';
import Button from '../../common/Button/Button';
import Form from 'react-bootstrap/Form';

import './InvitationModal.scss';

export default function InvitationModal({ show, role, emailChanged, onHide }) {
  const [linkCopied, setLinkCopied] = useState(false);

  const handleCopyLink = async () => {
    await navigator.clipboard.writeText(`${window.location.origin}/invite?token=${role?.invitation_token}`);
    
    setLinkCopied(true);
    debounceHideLinkCopied();
  }

  const debounceHideLinkCopied = useDebouncedCallback(() => {
    setLinkCopied(false);
  }, [2000])

  return (
    <Modal className='__modal __invitation-modal' show={show} onHide={onHide} backdrop='static'>
      <Modal.Header closeButton><h2>User Invitation</h2></Modal.Header>
      <Modal.Body>
        { emailChanged
        ? <><p className='new-link'>We've sent a new invitation to <strong>{ role?.invitation_email }</strong>.</p><p><strong>The previous invitation will be invalidated.</strong></p></>
        : <p>We've sent an email to invite <strong>{ role?.invitation_email }</strong> to your organization.</p>
        }
        <p>Alternatively, send the new user this link to accept the invitation:</p>

        <div className="link-field">
          <Form.Control value={`${window.location.origin}/invite?token=${role?.invitation_token}`} readOnly />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className='cancel' onClick={onHide}>Close</Button>
        <button className="confirm" onClick={handleCopyLink}>{ linkCopied ? 'Copied' : 'Copy Link' }</button>
      </Modal.Footer>
    </Modal>
  )
}
